import { logger } from 'monitor';

const MIN_ASPECT_RATIO = 0.6;
export const isAspectRatioValid = (photo: File) => {
  const image = new Image();
  image.src = URL.createObjectURL(photo);

  return new Promise<boolean>((resolve) => {
    image.onload = () => {
      logger.debug('validating aspect ratio', {
        MIN_ASPECT_RATIO,
        height: image.height,
        width: image.width,
      });

      const isPortrait = image.height > image.width;
      if (isPortrait) {
        resolve(image.width / image.height > MIN_ASPECT_RATIO);
        return;
      }
      resolve(image.height / image.width > MIN_ASPECT_RATIO);
    };
  });
};
